<template>
  <div>
    <div class="app-body">
      <app-header ref="header">
        <div slot="right"></div>
      </app-header>
      <el-container class="app-container mt-4">
        <el-main>
          <div class="app-head">
            <div>
              <h4 class="app-title">教师开户申请信息</h4>
              <div class="app-desc">查看教师开户申请信息，开通后可完善个人终身账户信息。</div>
            </div>
            <div>
              <router-link to="/joint">返回开户申请</router-link>
            </div>
          </div>
          <div class="app-form" v-loading="loading">
            <div class="mt-3">
              <el-alert v-if="isdel">
                对不起，你查询的信息已删除！
              </el-alert>
              <el-form v-show="!isdel" ref="form" label-width="120px">
                <el-form-item label="申请时间">
                  <div>{{ form.createtime }}</div>
                </el-form-item>
                <el-form-item label="状态">
                  <div><el-tag size="small" :type="organizationStatusType">{{ organizationjoinstatus[form.status] }}</el-tag></div>
                </el-form-item>
                <!-- <el-form-item label="教师照片">
                  <div>
                    <el-image v-if="form.pic" :src="imgPath(form.pic)" :preview-src-list="[imgPath(form.pic)]" fit="cover" style="width:5rem; height:6rem;"></el-image>
                  </div>
                </el-form-item> -->
                <el-form-item label="教师分类">
                  <div>{{ form.catename }}</div>
                </el-form-item>
                <el-form-item label="教师名称">
                  <div>{{ form.name }}</div>
                </el-form-item>
                <el-form-item label="手机号码">
                  <div>{{ form.mobile }}</div>
                </el-form-item>
                <!-- <el-form-item label="出生日期">
                  <div>{{ form.csny }}</div>
                </el-form-item>
                <el-form-item label="民族">
                  <div>{{ form.mz }}</div>
                </el-form-item>
                <el-form-item label="政治面貌">
                  <div>{{ form.zzmm }}</div>
                </el-form-item>
                <el-form-item label="职称">
                  <div>{{ form.zc }}</div>
                </el-form-item>
                <el-form-item label="学历">
                  <div>{{ form.xl }}</div>
                </el-form-item>
                <el-form-item label="专业">
                  <div>{{ form.zy }}</div>
                </el-form-item>
                <el-form-item label="工作单位">
                  <div>{{ form.workunit }}</div>
                </el-form-item>
                <el-form-item label="常住地址">
                  <div>{{ form.address }}</div>
                </el-form-item>
                <el-form-item label="个人简介">
                  <div class="d-pre">{{ form.info }}</div>
                </el-form-item>
                <el-form-item label="相关资格证书">
                  <div class="d-flex flex-wrap">
                    <template v-for="item in (form.zigepic ? form.zigepic.split(',') : [])">
                      <el-image :src="imgPath(item)" :preview-src-list="[imgPath(item)]" fit="cover" class="mr-1 mb-1" style="width:5rem; height:5rem;"></el-image>
                    </template>
                  </div>
                </el-form-item>
                <el-form-item label="所获荣誉">
                  <div class="d-flex flex-wrap">
                    <template v-for="item in (form.rongyupic ? form.rongyupic.split(',') : [])">
                      <el-image :src="imgPath(item)" :preview-src-list="[imgPath(item)]" fit="cover" class="mr-1 mb-1" style="width:5rem; height:5rem;"></el-image>
                    </template>
                  </div>
                </el-form-item> -->
                <!-- <el-form-item label="任教年级">
                  <div>{{ form.rjnj }}</div>
                </el-form-item>
                <el-form-item label="任教学科">
                  <div>{{ form.rjxk }}</div>
                </el-form-item> -->
                <el-form-item class="mt-3">
                  <el-button @click="doReturn">返回</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import { organizationStatusType } from '@/business/mixin/global';
import AppHeader from '../app-header';
import AppFooter from '../app-footer';
export default {
  mixins: [tools],
  components: { AppHeader, AppFooter },
  props: {
    id: String
  },
  data () {
    return {
      form: {
        id: '',
        cateid: '',
        name: '',
        linkman: '',
        tel: '',
        email: '',
        ccode: '',
        hy: '',
        content: '',
        status: 0
      },
      loading: false,
      isdel: false
    }
  },
  computed: {
    ...mapGetters({
      organizationjoinstatus: [types.STATUS.organizationjoinstatus],
    }),
    organizationStatusType() {
      return organizationStatusType(this.form.status);
    }
  },
  watch: {
    id() {
      this.getData();
    }
  },
  created () {
  },
  mounted() {
  },
  activated () {
    if (!this.form.id) {
      this.getData();
    }
    if (!this.organizationjoinstatus || !Object.keys(this.organizationjoinstatus).length) {
      this.$store.dispatch(types.STATUS.organizationjoinstatus);
    }
  },
  methods: {
    getData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.doGet({
        url: 'vue/teacher/join/'+ this.id,
        okcb: (json) => {
          if (json.isdel) {
            this.isdel = true;
          } else {
            this.form = Object.assign({}, json);
          }
        },
        cb: () => {
          this.$nextTick(() => this.loading = false);
        }
      });
    },
    doReturn() {
      this.$router.push('/joint');
    }
  }
}
</script>
<style lang="less" scoped>
.app {
  &-head {
    .flex();
    justify-content:space-between;
  }
  &-title {
    font-size:2rem;
  }
  &-desc {
    color:#555;
  }
  &-form {
    margin-top:2rem;
    padding:2rem;
    background-color:#fff;
    .shadow-black(0 0 6px 0, .03);
    form {
      .el-form-item {
        margin-bottom:0;
        max-width:600px;
        &.textarea {
          max-width:1000px;
        }
      }
    }
  }
}
</style>